export default "__VITE_ASSET__d15853c1__"